var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { deserialize } from '../../../../utils/serializr/serializr';
import { SoundCategory } from '../../../learnware/LearnwareEnums';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../../utils/serializr/schema/middle/withDefault';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { str_replace } from '../../../../utils/helper/helper_string';
import { runtime } from '../../../runtime/Runtime';
import { sleep } from '../../../../utils/helper/helper_time';
import { SndHowl } from './modules/SndHowl';
import { Ply } from '../ply/Ply';
export class Snd extends Ply {
    type = 'snd';
    soundCategory = SoundCategory.NotClassified;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get trait() {
        return this.parent;
    }
    get sndHowl() {
        return new SndHowl(this);
    }
    get sndEdit() {
        return new runtime.solidPackages.Edit.classes.SndEdit(this);
    }
    get src() {
        if (this.base64.length > 0) {
            this.scheduleForUpload();
            return this.base64;
        }
        return this.medFileInfo.nativeUrl;
    }
    static fromSerialized(ser = {}) {
        return deserialize(Snd, ser);
    }
    mp3Path_cached;
    get mp3Path() {
        if (this.filePath.includes('.mp3'))
            return this.filePath;
        const parts = this.filePath.split('/');
        const filename = str_replace('.ogg', '.mp3', parts[parts.length - 1]);
        return parts.slice(0, -1).concat('converted_mp3', filename).join('/') || this.mp3Path_cached;
    }
    set mp3Path(p) {
        this.mp3Path_cached = p;
    }
    static get serializeInfo() {
        return {
            extends: Ply.serializeInfo,
            props: {
                //  durationInSeconds_save: disgardOldValue(alias('duration', primitive)),
                soundCategory: withDefault(primitive, SoundCategory.NotClassified),
                mp3Path: true,
            },
            afterDeserialize: async ({ target, context }) => {
                if (!runtime.solidBrowserRuntime)
                    return;
                if (context.rootContext.target.type !== 'question')
                    return; // only preload question sounds
                if (runtime.browserRuntime.app.appBoot.timeSinceStartup < 10000) {
                    await sleep(10000);
                }
                runtime.runtimeScheduler.scheduleIdleBackgroundTask(() => {
                    runtime.solidBrowserRuntime.browserPreload.preloadAudio(target.src);
                });
                if (runtime.runtimePermissions.hasEditFunctionality && ['question', 'bundle'].includes(context.rootContext.target.type)) {
                    context.rootContext.target.measuredAssetSize += Math.ceil(target.fileSize / 1000);
                }
                if (runtime.runtimePermissions.hasEditFunctionality && target.durationInSeconds === 0) {
                    setTimeout(target.sndEdit.detectAndUpdateDuration, 10);
                }
            },
        };
    }
}
__decorate([
    editable()
], Snd.prototype, "soundCategory", void 0);
__decorate([
    memoize
], Snd.prototype, "sndHowl", null);
__decorate([
    memoize
], Snd.prototype, "sndEdit", null);
__decorate([
    override
], Snd.prototype, "src", null);
__decorate([
    memoize
], Snd, "serializeInfo", null);
